import { text_colorTextPrimary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  color: ${text_colorTextPrimary};
`

export const titleRow = css`
  display: flex;
  align-items: center;
  gap: ${spacing(3)};
`

export const title = css`
  margin: 0;
  ${font_md};
  font-family: ${font_family_weight_medium};
`

export const body = css`
  margin: 0;
  ${font_md};
  font-family: ${font_family_weight_regular};
  line-height: 20px;
`

export const list = css`
  margin: 0;
  padding-left: ${spacing(6)};
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  ${font_md};
  font-family: ${font_family_weight_regular};
  line-height: 20px;
`

export const action = css`
  font-family: ${font_family_weight_medium};
`

export default { container, titleRow, title, body, list, action }
